import { useModal, useNFTContext } from "../../../../utils/ModalContext";
import { useEffect, useState } from "react";
import { FaDiscord, FaRegArrowAltCircleUp, FaArrowUp, FaTelegram, FaWallet } from "react-icons/fa";
import { MdNotes } from "react-icons/md";
import Button from "../../../../common/button";
import NavWrapper from "./Header.style";
import MobileMenu from "../mobileMenu/MobileMenu";
import logo from "../../../../assets/images/logo/logo.png";
import {  useNavigate } from "react-router-dom";
import { useApiContract, useMoralis, useNativeBalance } from "react-moralis";
import { FiLogOut } from "react-icons/fi";
import { ImSpinner } from "react-icons/im";
import { func } from "prop-types";
import { useLayoutEffect } from "react";
import y5Abi from "../../../../controllers/abiY5.json"


const y5Options = {
  address: process.env.REACT_APP_Y5_ADDRESS,
  abi: y5Abi,
  chain: "bsc"
}
const Header = () => {

  const {authenticate, isAuthenticated, user, logout, isLoggingOut, Moralis, account} = useMoralis()
  const { walletModalHandle, noWalletModalHandle, oopsModalHandle,shareModalHandle } = useModal();
  const [isMobileMenu, setMobileMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const {userBalance} = useNFTContext();
  // const {data, isFetching, runContractFunction} = useApiContract({...y5Options, functionName:"balanceOf", params:{account: user?.get("ethAddress") || account}})

  const handleMobileMenu = () => {
    setMobileMenu(!isMobileMenu);
  };

  const navigate = useNavigate();
  useLayoutEffect(() => {
    const header = document.getElementById("navbar");
    const handleScroll = window.addEventListener("scroll", () => {
      if (window.pageYOffset > 50) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    });

    // const fetchData = async() => {
    //   await runContractFunction();
    // }
    // fetchData();
    return () => {
      window.removeEventListener("sticky", handleScroll);
    };
  }, []);

  const handleWallet = async (e) => {
    setLoading(true);
    const isInstalled = await Moralis.isMetaMaskInstalled();
    console.log('isInstalled', isInstalled)
    setLoading(false);
    if(isInstalled){
      walletModalHandle();
    }
    else noWalletModalHandle(e);
  }

  return (
    <NavWrapper className="bithu_header" id="navbar">
      <div className="container">
        {/* Main Menu Start */}
        <div className="bithu_menu_sect">
          <div className="bithu_menu_left_sect">
            <div className="logo">
              <a href="/">
                <img src={logo} alt="AlphaOctopus nft logo" style={{height:75}} />
              </a>
            </div>
          </div>
          <div className="bithu_menu_right_sect bithu_v1_menu_right_sect">
            {/* <div className="bithu_menu_list">
              <ul>
                <li>
                  <a href="#home">Home</a>
                </li>
                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#roadmap">Roadmap</a>
                </li>
                <li>
                  <a href="#team">Team</a>
                </li>
                <li>
                  <a href="#faq">FAQ</a>
                </li>
               
              </ul>
            </div> */}
            <div className="bithu_menu_btns">
            {isAuthenticated && <Button lg variant="outline" className="menu_btn" disabled={isLoggingOut} onClick={() => logout()}>
                <FiLogOut title="Logout"/>
              </Button>}
              <button className="menu_btn" onClick={(e) => walletModalHandle()}>
              {/* {loading ? <ImSpinner/> : <FaWallet /> } */}
                {isAuthenticated && <span >{(user?.get('ethAddress')).substring(0,4)}...</span>} &nbsp; &nbsp; 
                {isAuthenticated? <span>({userBalance} ETH)</span>: loading ? "Loading..." : <>Connect <FaWallet title="Connect " /></>} <br />
                
              </button>
              
            
              <Button
                lg
                variant="hovered"
                className="connect_btn"
                onClick={(e) => handleWallet(e)}
              >
                
                {loading ? <ImSpinner/> : <FaWallet /> }
                {isAuthenticated && <span >{(user?.get('ethAddress')).substring(0,4)}...</span>} &nbsp; &nbsp; 
                {isAuthenticated? <span>({userBalance} ETH)</span>: loading ? "Loading..." : "Connect Wallet" } <br />
                
              </Button>
              
              {isAuthenticated && <Button lg variant="outline" className="join_btn" disabled={isLoggingOut} onClick={() => logout()}>
                <FiLogOut title="Logout"/>
              </Button>}
            </div>
          </div>
        </div>
        {/* <!-- Main Menu END --> */}
        {/* {isMobileMenu && <MobileMenu mobileMenuhandle={handleMobileMenu} />} */}
      </div>
    </NavWrapper>
  );
};

export default Header;
